export default __webpack_public_path__ + "static/photo_sav-49dafe05396ec7710ff4d2b22c946aaf.png";